import api from '../config/axiosConfig';

export const MotivosBajaService = {
    getMotivos: async (token) => {
        try {
            const response = await api.get('/ajustes/motivosbaja',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.motivos;
        } catch (error) {
            console.error('Error en MotivosBajaService.getMotivos:', error);
            throw error;
        }
    },
};
